/**
 * ステータス（プレイ済み / 視聴済み 等）の色。
 *
 * これは装飾ではなく**データの符号化**。5つが互いに識別できることが機能要件で、
 * ユーザーの好みで動かしてはいけない。
 *
 * 特に status 1 は以前 `primary.main` を参照していたため、
 * プロフィールのアクセント色（入れ子の ThemeProvider で primary を差し替える）に
 * 追従してしまい、シアンを選ぶと status 2 と、アンバーを選ぶと status 3 と
 * ほぼ同色になる状態だった。テーマトークンではなく固定値にすること。
 *
 * 同じ色が6ファイルに個別に書かれていたのが再発の原因なので、
 * **ステータス色を使うときは必ずここを参照する**こと。
 */

export const STATUS_COLOR = {
  /** プレイ済み / 視聴済み。値は従来の primary と同じなので既存の見た目は変わらない */
  1: '#d9ff00',
  /** プレイ中 / 視聴中。従来の info.main 相当 */
  2: '#29b6f6',
  /** 中断。従来の warning.main 相当 */
  3: '#ffa726',
  /** 積みゲー */
  4: '#b99a71',
  /** ウィッシュリスト。従来の secondary.main 相当 */
  5: '#92b304',
} as const;

// 2/3/5 の呼び出し側はまだ info.main / warning.main / secondary.main を参照している。
// テーマ側でそれらを変えるとステータスの意味色がずれるので、いずれここへ寄せること。
// 今回はアクセント色に追従してしまう 1 のみを移行した（バグ修正が目的のため）。
